/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import _ from 'lodash';
import { GridResults } from 'model/reports/GridResults';
import { GridTable } from 'components/reports/base/GridTable';
import styles from '../../styles/components/reports/base/GridTableReport.module.css';
import { getPercentLabelForGrid, getPercentForGrid } from 'helpers/results';

export interface GridResponseTableReportData {
  report: GridResults;
}

export const GridResponseTableReport: React.FC<GridResponseTableReportData> = ({
  report,
}) => {
  return (
    <GridTable
      cols={_.map(report.columnLabels, cl => (
        <span className={styles.headerItem}>{cl}</span>
      ))}
      rows={_.map(report.rowLabels, rl => {
        const percentLabel = getPercentLabelForGrid(report.requiredStrategy);
        const rowElem = (
          <div>
            <span className={styles.tableItem}>{rl}</span>
            <span className={styles.measurements}>
              Count ({percentLabel} %)
            </span>
          </div>
        );
        return rowElem;
      })}
      elementRenderer={(colIndex: number, rowIndex: number) => {
        const value = _.find(
          report.data,
          d => d.columnIdx === colIndex && d.rowIdx === rowIndex
        );
        if (value) {
          const percent = getPercentForGrid(report.requiredStrategy, value);
          return (
            <span
              className={styles.tableItem}
            >{`${value.count} (${percent}%)`}</span>
          );
        } else {
          return <span className={styles.tableItem}>Not found</span>;
        }
      }}
    />
  );
};
